// Where the Tasks pages live: /tasks on the desktop, /companion/tasks on a
// phone (and as the iPhone app's web screen), so a link stays in the shell
// it was followed from (the useWorkflowsBase pattern). A task's run view
// and a team task's page are the Workflows area's, which the companion
// mounts too.

import { useLocation } from "react-router-dom";

export function useTasksBase(): string {
  const { pathname } = useLocation();
  return pathname === "/companion" || pathname.startsWith("/companion/") ? "/companion/tasks" : "/tasks";
}

export const onPhone = (base: string) => base.startsWith("/companion");

export const taskPath = (base: string, taskId: string) => `${base}/${encodeURIComponent(taskId)}`;

/** The task's run (`run_path`: "/workflows/runs/<id>" or "/workflows/jobs/<id>") in the same shell. */
export const runPathIn = (base: string, runPath: string) => (onPhone(base) && runPath.startsWith("/workflows/") ? `/companion${runPath}` : runPath);

/** Where the page goes when Tasks are switched off: Home, or Today on a phone. */
export const tasksOffPath = (base: string) => (onPhone(base) ? "/companion/today" : "/dashboard");
